import PropTypes from 'prop-types';
import React from 'react';
import { DollarAmount } from './Money';
import RowDisplay from '../../common/RowDisplay';
import EditModal from '../../common/modal/EditModal';
import HouseholdMonthlyIncomeForm from './HouseholdMonthlyIncomeForm';
import { HOUSEHOLD_MONTHLY_INCOME_FORM } from '../constants';
var HouseholdMonthlyIncome = function HouseholdMonthlyIncome(_ref) {
  var contact = _ref.contact,
    callbacks = _ref.callbacks;
  var editModal = /*#__PURE__*/React.createElement(EditModal, {
    id: "edit-household-monthly-income-modal",
    editButtonId: "edit-household-monthly-income",
    formName: HOUSEHOLD_MONTHLY_INCOME_FORM,
    header: "Edit Household Gross Monthly Income",
    size: "large"
  }, /*#__PURE__*/React.createElement(HouseholdMonthlyIncomeForm, {
    contact: contact
  }));
  return /*#__PURE__*/React.createElement(RowDisplay, {
    className: "household-monthly-income",
    editSection: editModal,
    label: /*#__PURE__*/React.createElement("div", null, "Household Gross", /*#__PURE__*/React.createElement("br", null), "Monthly Income")
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-12"
  }, /*#__PURE__*/React.createElement("p", {
    className: "profile-value"
  }, /*#__PURE__*/React.createElement(DollarAmount, {
    value: contact.gross_monthly_income
  }))));
};
HouseholdMonthlyIncome.propTypes = {
  contact: PropTypes.shape({
    gross_monthly_income: PropTypes.number
  }).isRequired
};
export default HouseholdMonthlyIncome;
//# sourceMappingURL=HouseholdMonthlyIncome.js.map